<template>
  <div class="section">
    <div class="inform">
      <template v-for="(item , index) in informlist">
        <div :class="{inform_transition:item.animate === index}"  @click="informClick(item)" v-text="item.title" ></div>
      </template>
    </div>

    <div class="imgView">
      <img src="@/assets/data/product_1.png" />
    </div>

    <div class="imgView">
      <img src="@/assets/data/ad_3.png" />
    </div>

    <!--

      카테고리

     -->
    <div class="category">
      <div>
        <div class="category_img_view">
          <img src="@/assets/icon/category_1.png"/>
        </div>
        <div class="category_name">
          농산물
        </div>
      </div>

      <div>
        <div class="category_img_view">
          <img src="@/assets/icon/category_2.png"/>
        </div>
        <div class="category_name">
          농산물
        </div>
      </div>

      <div>
        <div class="category_img_view">
          <img src="@/assets/icon/category_3.png"/>
        </div>
        <div class="category_name">
          농산물
        </div>
      </div>

      <div>
        <div class="category_img_view">
          <img src="@/assets/icon/category_4.png"/>
        </div>
        <div class="category_name">
          농산물
        </div>
      </div>

      <div>
        <div class="category_img_view">
          <img src="@/assets/icon/category_5.png"/>
        </div>
        <div class="category_name">
          농산물
        </div>
      </div>

      <div>
        <div class="category_img_view">
          <img src="@/assets/icon/category_1.png"/>
        </div>
        <div class="category_name">
          농산물
        </div>
      </div>

    </div>

    <!--

      영상

     -->
    <div class="home_video">
      <div class="home_video_type flex_row_center">
        <div @click="videoType(1)" :class="home_video_type === 1 ? 'home_video_type_on' :'' ">
          추천 영상
        </div>
        <div @click="videoType(2)" :class="home_video_type === 2 ? 'home_video_type_on' :'' ">
          인기 영상
        </div>
      </div>
      <videolist :list="videolist" :click="videoClick"></videolist>
    </div>

    <div class="imgView">
      <img src="@/assets/data/ad_1.png" />
    </div>

    <div class="imgView">
      <img src="@/assets/data/ad_2.png" />
    </div>

  </div>
</template>

<script>

  import waves from '@/directive/waves'
  import videolist from '@/components/videolist'

  export default {
    name: 'Home',
    directives: { waves },
    components:{videolist},
    data () {
      return {
        home_video_type:1
        ,videolist:[]
        ,rmdvideolist:[
          {
            id:0
            ,imgURL : require('@/assets/data/product_1.png')
            ,title : '곶감과 전기 밥손으로 만드는 약식곶감과 전기 밥손으로 만드는 약식곶감과 전기 밥손으로 만드는 약식곶감과 전기 밥손으로 만드는 약식곶감과 전기 밥손으로 만드는 약식곶감과 전기 밥손으로 만드는 약식'
            ,desc :'동영상 간략 정보가 노출됩니다.'
            ,rmd : true
            ,viewCount : 300
            ,mark : true
            ,markCount : 300
            ,date : '2019-01-01'
          },
          {
            id:1
            ,imgURL : require('@/assets/data/product_1.png')
            ,title : '곶감과 전기 밥손으로 만드는 약식곶감과 전기 밥손으로 만드는 약식곶감과 전기 밥손으로 만드는 약식곶감과 전기 밥손으로 만드는 약식곶감과 전기 밥손으로 만드는 약식곶감과 전기 밥손으로 만드는 약식'
            ,desc :'동영상 간략 정보가 노출됩니다.'
            ,rmd : true
            ,viewCount : 300
            ,mark : true
            ,markCount : 300
            ,date : '2019-01-01'
          }
        ],
        hotvideolist:[
        {
          id:0
          ,imgURL : require('@/assets/data/product_1.png')
          ,title : '곶감과 전기 밥손으로 만드는 약식곶감과 전기 밥손으로 만드는 약식곶감과 전기 밥손으로 만드는 약식곶감과 전기 밥손으로 만드는 약식곶감과 전기 밥손으로 만드는 약식곶감과 전기 밥손으로 만드는 약식'
          ,desc :'동영상 간략 정보가 노출됩니다.'
          ,rmd : false
          ,viewCount : 300
          ,mark : true
          ,markCount : 300
          ,date : '2019-01-01'
        },
        {
          id:1
          ,imgURL : require('@/assets/data/product_1.png')
          ,title : '곶감과 전기 밥손으로 만드는 약식곶감과 전기 밥손으로 만드는 약식곶감과 전기 밥손으로 만드는 약식곶감과 전기 밥손으로 만드는 약식곶감과 전기 밥손으로 만드는 약식곶감과 전기 밥손으로 만드는 약식'
          ,desc :'동영상 간략 정보가 노출됩니다.'
          ,rmd : false
          ,viewCount : 300
          ,mark : false
          ,markCount : 300
          ,date : '2019-01-01'
        }
      ]
        ,informlist:[
          {
            id:1,
            title:'공지사항이 노출됩니다.1',
            animate:0
          },
          {
            id:2,
            title:'공지사항이 노출됩니다.2',
            animate:1
          },
          {
            id:3,
            title:'공지사항이 노출됩니다.3',
            animate:2
          }
        ]
        ,informinfo:[
          {
            id:0,
            title:'',
            index:0
          }
        ]
      }
    },
    created(){
      this.setInform();

      this.videolist = this.rmdvideolist;
    },
    mounted () {
    },
    methods: {
      setInform(){
        setInterval(()=>{
          this.informlist[ 0 ].animate = 0;
          setTimeout (() => {
            this.informlist.push ( this.informlist[ 0 ] );
            this.$nextTick(()=>{
              this.informlist[0]['animate'] = -1;
              this.informlist.shift ();
            });
          },500 );
        },2000);
      },
      informClick(info){
        console.log(info.title);
      },
      videoType(index){
        this.home_video_type = index;
        if(index === 1){
          this.videolist = this.rmdvideolist;
        }else{
          this.videolist = this.hotvideolist;
        }
      },
      videoClick(info){
        console.log(info);
      }

    }
  }
</script>

<style scoped>
  .inform {
    position: relative;
    padding: 0 0.556rem 0 1.444rem;
    margin: 0.472rem 0;
    height: 0.458rem;
    overflow: hidden;
    display: block;
    width: 100%;
  }
  .inform div {
    color: #9F9F9F;

  }
  .inform:before {
    content: '';
    position: absolute;
    background-image: url('../../../assets/icon/icon_inform.png');
    background-size: cover;
    background-repeat: no-repeat;
    width: 0.528rem;
    height: 0.423rem;
    top: -0.042rem;
    left: 0.556rem;
  }

  .inform_transition {
    -webkit-transition: all .5s ease-in;
    -moz-transition: all .5s ease-in;
    transition: all .5s ease-in;
    margin-top: -0.417rem;
  }

  .category {
    white-space: nowrap;
    margin: 1.111rem 0 1.111rem 0.556rem;
    overflow-x:auto ;
  }

  .category > div {
    display: inline-block;
    margin: 0 0.486rem 0 0 ;
  }


  .category_img_view {
    background-color: #F8F7F4;
    -webkit-border-radius: 50%;
    -moz-border-radius: 50%;
    border-radius: 50%;
    height: 1.528rem;
    width: 1.528rem;
    display: inline-block;
  }

  .category_name {
    text-align: center;
    padding: 0.278rem 0 0 0 ;
  }

  .category_img_view img {
    width: 100%;
    height: 100%;
  }
  .imgView{
    width: 100%;
    display: flex;
  }

  .imgView img {
    width: 100%;
    height: 100%;
  }

  .home_video {
    border-top: 1px solid #E3E3E3;
  }
  .home_video_type > div:last-child {
    position: relative;
  }

  .home_video_type_on {
    color: #F15929;
  }

  .home_video_type > div {
    width: 50%;
    display: flex;
    justify-content: center;
    padding: 0.493rem 0;
  }
  .home_video_type > div:last-child:before {
    content: '';
    position: absolute;
    left: 0;
    height: 0.458rem;
    width: 0.014rem;
    border-left: 1px solid #E3E3E3;
  }
</style>



// WEBPACK FOOTER //
// src/views/Main/Home/Home.vue